
export const personalChildren = [
    {
        path: '/myInfo',
        name: 'myInfo',
        component: () => import('@/views/page/myInfo'),
        meta: { active: 'myInfo', name: '个人信息', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/c3f621afba4c43a4a09e4d31776e19da.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/02fb0cc4f84845e69543923d0e0ef1e6.png', tabShow: true }
    }, {
        path: '/myCourse',
        name: 'myCourse',
        component: () => import('@/views/page/myCourse'),
        meta: { active: 'myCourse', name: '我的课程', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/5a0d6c4a2b8a42409be019b36a319a99.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/dcd232d10dc3489aadaae7820e5d9a6d.png', tabShow: true }
    }, {
        path: '/myOrder',
        name: 'myOrder',
        component: () => import('@/views/page/myOrder'),
        meta: { active: 'myOrder', name: '我的订单', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/83626c6a465c4f7db35a5997778ada4d.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/5f12c350e32348a3997d0aac466f6513.png', tabShow: true }
    }, {
        path: '/myCar',
        name: 'myCar',
        component: () => import('@/views/page/myCar'),
        meta: { active: 'myCar', name: '购物车', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/c0789d9e31de48fb91bbdd18a44b876d.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/10c664dd750142df9906d58517941476.png', tabShow: true }
    }, {
        path: '/myExam',
        name: 'myExam',
        component: () => import('@/views/page/myExam'),
        meta: { active: 'myExam', name: '我的考试', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3cf0dc654fec4c32aecf5d3c93137c29.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3045dff632f847318494d9b4b0c95a2b.png', tabShow: true }
    }, {
        path: '/myCertificate',
        name: 'myCertificate',
        component: () => import('@/views/page/myCertificate'),
        meta: { active: 'myCertificate', name: '我的证书', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/1c421cb0f71746af8fd95624bef2d972.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/1f735bb6852e40cc97735e13c6cacf2a.png', tabShow: true }
    }, {
        path: '/myDiscuss',
        name: 'myDiscuss',
        component: () => import('@/views/page/myDiscuss'),
        meta: { active: 'myDiscuss', name: '我的讨论', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/c07f591ab3a54c3abd6c0b72e0ba6586.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/875ee9db84964f688165f26af986acf9.png', tabShow: true }
    }, {
        path: '/myCollection',
        name: 'myCollection',
        component: () => import('@/views/page/myCollection'),
        meta: { active: 'myCollection', name: '我的收藏', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/dc8ab54f47b3448081a7742c06db65db.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/0fe6a21484764379b479ba590dddc0c1.png', tabShow: true }
    }, {
        path: '/myMoney',
        name: 'myMoney',
        component: () => import('@/views/page/myMoney'),
        meta: { active: 'myMoney', name: '我的金币', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/cbde52cb0912468fac6d4665dc96b610.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/62b80d0e8f314e339181a1712f28a478.png', tabShow: true }
    }, {
        path: '/myNotification',
        name: 'myNotification',
        component: () => import('@/views/page/myNotification'),
        meta: { active: 'myNotification', name: '我的通知', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/cbde52cb0912468fac6d4665dc96b610.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/62b80d0e8f314e339181a1712f28a478.png', tabShow: true }
    }, {
        path: '/myTotalExam',
        name: 'myTotalExam',
        component: () => import('@/views/page/myTotalExam'),
        meta: { active: 'myExam', name: '我的考试', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3cf0dc654fec4c32aecf5d3c93137c29.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3045dff632f847318494d9b4b0c95a2b.png', tabShow: false }
    }, {
        path: '/myExamResult',
        name: 'myExamResult',
        component: () => import('@/views/page/myExamResult'),
        meta: { active: 'myExam', name: '我的考试', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3cf0dc654fec4c32aecf5d3c93137c29.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3045dff632f847318494d9b4b0c95a2b.png', tabShow: false }
    }, {
        path: '/myExamRecord',
        name: 'myExamRecord',
        component: () => import('@/views/page/myExamRecord'),
        meta: { active: 'myExam', name: '我的考试', icon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3cf0dc654fec4c32aecf5d3c93137c29.png', activeIcon: 'https://file.jycyfww.com/wangchuang/qc/prod/static/img/3045dff632f847318494d9b4b0c95a2b.png', tabShow: false }
    },
]